"use client";

import React from "react";
import { useSelector } from "react-redux";
import { cn } from "@/lib/utils";
import Header from "@/components/custom/common/Header";
import Footer from "@/components/custom/common/Footer";

export default function DashboardContent({ children }) {
    const { isOpen } = useSelector((state) => state.toggle);

    return (
        <section
            className={cn(
                "flex flex-col flex-1 w-full max-h-screen overflow-y-auto transition-all duration-300 ease-in-out",
                isOpen ? "lg:ml-64" : "lg:ml-20"
            )}
        >
            <Header />
            <div className="mx-auto w-full p-2 md:p-6">{children}</div>
            <Footer />
        </section>
    );
}
